import { gql } from '@apollo/client';

export const UPDATE_LEAGUE_MESSAGE = gql`
  mutation UpdateLeagueMessage($input: UpdateLeagueMessageInput!) {
    updateLeagueMessage(input: $input) {
      leagueMessage {
        id
        text
        createdAt
        user {
          id
          fullName
        }
      }
      errors
    }
  }
`;
